import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FilterSearchComponent from '../common/FilterSearchComponent';
import * as salesCatalystActions from '../../actions/salesCatalystActions';
import { PREFERENCE_SALES_CATALYST, PREFERENCE_BRAND_CATALYST,
  PREFERENCE_SALES_CATALYST_STUDY_FAMILY, PREFERENCE_BRAND_CATALYST_STUDY_FAMILY } from '../../constants';

const scStudyFamily = `${PREFERENCE_SALES_CATALYST}.${PREFERENCE_SALES_CATALYST_STUDY_FAMILY}`;
const bcStudyFamily = `${PREFERENCE_BRAND_CATALYST}.${PREFERENCE_BRAND_CATALYST_STUDY_FAMILY}`;

class PreferencesCommonFilterSearch extends Component {
  constructor(props) {
    super(props);
    const { field } = this.props;
    const defaultval = this.getKeyData(field.dbKey);
    let moduleFilters;
    let studyFamilyId = this.getKeyData(this.getStudyFamilyDBKeyForGivenMenu(field.menuName));
    if (studyFamilyId === -1) {
      studyFamilyId = this.getFirstStudyFamilyId();
    }
    const isModuleFiltersValid = this.validatePreferencesData(defaultval, studyFamilyId);
    const filters = this.getPreferencesFilters(defaultval, studyFamilyId);
    if (!isModuleFiltersValid) {
      moduleFilters = [];
    } else {
      moduleFilters = defaultval;
    }
    this.state = {
      selectedFilter: filters,
      studyFamilyId,
      moduleFilters,
      resetNodes: false,
    };
  }

  /* eslint-disable camelcase */
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { field, modifiedPreferences } = this.props;
    const { selectedFilter, moduleFilters, studyFamilyId } = this.state;
    if (modifiedPreferences !== nextProps.modifiedPreferences) {
      let changedModuleFilters = this.getKeyData(field.dbKey, false, nextProps.modifiedPreferences);
      const changedStudyFamilyId = this.getKeyData(this.getStudyFamilyDBKeyForGivenMenu(field.menuName),
                                              false, nextProps.modifiedPreferences);
      const isModuleFiltersValid = this.validatePreferencesData(changedModuleFilters, changedStudyFamilyId);
      if (!isModuleFiltersValid) {
        changedModuleFilters = [];
      }
      const changedFilterVal = this.getPreferencesFilters(changedModuleFilters, changedStudyFamilyId);
      /** if (_.isEmpty(changedModuleFilters) || changedFilterVal.length === 0) {
        changedModuleFilters = [];
      } */
      let changedResetNodes = false;
      if (studyFamilyId !== changedStudyFamilyId) {
        changedResetNodes = true;
      }
      if (!_.isEqual(selectedFilter, changedFilterVal) || !_.isEqual(moduleFilters, changedModuleFilters) ||
      studyFamilyId !== changedStudyFamilyId) {
        this.setState({
          selectedFilter: changedFilterVal,
          studyFamilyId: changedStudyFamilyId,
          moduleFilters: changedModuleFilters,
          resetNodes: changedResetNodes,
        });
      }
    }
  }


  getKeyData = (key, defaultData, newData) => {
    const { modifiedPreferences, userPreference } = this.props;
    const keys = key.split('.');
    let dataKey;
    if (newData !== undefined) {
      dataKey = newData;
    } else {
      dataKey = defaultData ? userPreference : modifiedPreferences;
    }
    return !_.isEmpty(dataKey) ? dataKey[keys[0]][keys[1]] : undefined;
  }

  getStudyFamilyDBKeyForGivenMenu = menuName => {
    if (menuName === 'SalesCatalyst') {
      return scStudyFamily;
    } if (menuName === 'BrandCatalyst') {
      return bcStudyFamily;
    }
    return '';
  }

  getFirstStudyFamilyId = () => {
    const { field, scStudies, studies, bcStudies } = this.props;
    if (field.menuName === 'SalesCatalyst') {
      return scStudies[0].id;
    }
    if (field.menuName === 'BrandCatalyst') {
      return bcStudies[0].id;
    }
    return studies[0].id;
  }

  getFirstProductNoForGivenStudyFamilyId = studyFamilyId => {
    const { field, scStudies, studies, bcStudies } = this.props;
    if (field.menuName === 'SalesCatalyst') {
      const selectedStudyGroup = _.find(scStudies, { id: studyFamilyId });
      if (selectedStudyGroup !== undefined) {
        return selectedStudyGroup.sl[0].pn;
      }
      return scStudies[0].sl[0].pn;
    }
    if (field.menuName === 'BrandCatalyst') {
      const selectedStudyGroup = _.find(bcStudies, { id: studyFamilyId });
      if (selectedStudyGroup !== undefined) {
        return selectedStudyGroup.sl[0].pn;
      }
      return bcStudies[0].sl[0].pn;
    }
    return studies[0].sl[0].pn;
  }

  searchFilterFn = (searchVal, callback) => {
    const { field, loginResponse, activeAccountId } = this.props;
    if (field.action !== undefined) {
      const filterSearchParams = {
        token: loginResponse.data.token,
        uid: loginResponse.data.uid,
        accountId: activeAccountId,
        reportName: field.action.type,
        searchText: searchVal,
        productNo: this.getFirstProductNoForGivenStudyFamilyId(this.state.studyFamilyId),
      };
      this.props.salesCatalystActions[field.action.name](filterSearchParams)
        .then(response => {
          const responseData = [];
          if (response !== undefined && response && response.length > 0) {
            response.forEach(data => {
              responseData.push({
                value: data.subCategory,
                label: data.categoryLabel,
              });
            });
            callback(responseData);
          } else {
            callback(responseData);
          }
        });
    }
  };

  getSelFilterFn = filters => {
    const { field, updatePreferences } = this.props;
    const { studyFamilyId, moduleFilters } = this.state;
    const node = _.cloneDeep(filters);
    const modifiedNode = _.cloneDeep(moduleFilters);
    if (_.isEmpty(modifiedNode)) {
      modifiedNode.push({ studyFamilyId, filters: node });
    } else {
      const index = _.findIndex(modifiedNode, { studyFamilyId });
      if (index >= 0) {
        modifiedNode[index] = { studyFamilyId, filters: node };
      } else {
        modifiedNode.push({ studyFamilyId, filters: node });
      }
    }
    updatePreferences(
      field.dbKey,
      modifiedNode,
    );
  }


  validatePreferencesData = filterData => {
    /**
     * This method will make sure if data is stored in the old format it will ignore it
     * and pass empty array. If the data is stored in the new format it will send the respective
     * study family id data
     */
    if (!_.isEmpty(filterData)) {
      const data = filterData[0];
      if (data.studyFamilyId === undefined) {
        return false;
      }
      return true;
    }
    return false;
  }

  getPreferencesFilters = (filterData, studyFamilyId) => {
    /**
     * This method will make sure if data is stored in the old format it will ignore it
     * and pass empty array. If the data is stored in the new format it will send the respective
     * study family id data
     */
    if (!_.isEmpty(filterData)) {
      let data = filterData[0];
      if (data.studyFamilyId === undefined) {
        return [];
      }
      data = _.find(filterData, { studyFamilyId });
      return data === undefined ? [] : data.filters;
    }
    return [];
  }


  render() {
    const { selectedFilter } = this.state;
    return (
      <div>
        <FilterSearchComponent
          searchFilterFn={this.searchFilterFn}
          selectedFilter={selectedFilter}
          additionalStyles={{ right: '0', position: 'inherit', width: '100%', borderRadius: '10px' }}
          getSelFilterFn={this.getSelFilterFn}
          resetNodes={this.state.resetNodes}
        />
      </div>
    );
  }
}

PreferencesCommonFilterSearch.propTypes = {
  field: PropTypes.shape({
    values: PropTypes.arrayOf(PropTypes.string),
    defaultValue: PropTypes.arrayOf(PropTypes.shape({})),
    dbKey: PropTypes.string,
    menuName: PropTypes.string,
    action: PropTypes.shape({
      name: PropTypes.string,
      type: PropTypes.string,
    }),
  }),
  style: PropTypes.shape({
    width: PropTypes.string,
  }),
  // label: PropTypes.string,
  updatePreferences: PropTypes.func,
  scStudies: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    sl: PropTypes.arrayOf(PropTypes.shape({
      pn: PropTypes.number
    })),
  })),
  bcStudies: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    sl: PropTypes.arrayOf(PropTypes.shape({
      pn: PropTypes.number
    })),
  })),
  studies: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    sl: PropTypes.arrayOf(PropTypes.shape({
      pn: PropTypes.number
    })),
  })),
  modifiedPreferences: PropTypes.shape({}),
  userPreference: PropTypes.shape({}),
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
    }),
  }),
  activeAccountId:PropTypes.number,
  salesCatalystActions: PropTypes.shape({}),
};


function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    scStudies: state.study.salesCatalystStudies,
    bcStudies: state.study.insight360studies,
    studies: state.study.studies,
    userPreference: state.preferences.userPreferences,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    salesCatalystActions: bindActionCreators(salesCatalystActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  )(PreferencesCommonFilterSearch);
